import { gql } from '@apollo/client';

export const getAssignedLineInfo = gql`
  query getAssignedLinesInfo($id: String!) {
    SalesforceManagement {
      entities {
        businessPartnerLine(id: $id) {
          id
          views {
            SalesforceManagement_all {
              properties {
                LineID {
                  id
                  views {
                    PlanConfigManagement_all {
                      properties {
                        Name
                      }
                    }
                  }
                }
                CreditLimit
                CreditLimitCurrency {
                  Id
                  Title
                }
                GracePeriod
                BusinessPartnerID {
                  id
                }
                Status
                LineCommissionType
                LineCommissionValue
                ValueCurrency {
                  Id
                  Title
                }
                LineCommissionRate
                ApplicableOn {
                  Id
                  Title
                }
              }
            }
          }
        }
      }
    }
  }
`;

export function updateLineCreditLimit() {
  return gql`
    mutation updateLineCreditLimit(
      $entityId: String!
      $selectedBusinessPartnerLineIds: [String!]!
      $creditLimit: Long!
      $creditLimitCurrency: String!
      $gracePeriod: Long!
    ) {
      salesforceManagement {
        entities {
          businessPartner {
            salesforceManagement {
              updateLineCreditLimit(
                entityId: $entityId
                selectedBusinessPartnerLineIds: $selectedBusinessPartnerLineIds
                creditLimit: $creditLimit
                creditLimitCurrency: $creditLimitCurrency
                gracePeriod: $gracePeriod
              ) {
                id
              }
            }
          }
        }
      }
    }
  `;
}
